<script setup>
  import { defineProps, defineEmits } from "vue";
  const emit = defineEmits(['back']);
  const props = defineProps({
    title: {
      type: String,
      default: "Enter Your title",
    },
  });


  const handleBack = () => {
    emit("back");
  };
</script>

<template>
  <div class="page-title">
    <el-page-header title="離開" @back="handleBack">
      <!--內容-->
      <template #content>
        <span> {{ title }} </span>
      </template>
    </el-page-header>
  </div>
</template>

<style lang="scss" scoped>
  .page-title {
    padding: 10px 0;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    h1 {
      font-size: 1.4rem;
      line-height: 36px;
      color: #606266;
      font-weight: bold;
      margin-right: 20px;
    }
  }
</style>
